module.exports = __webpack_public_path__ + "static/media/SUN_HELM.daefdc5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/SUN_HELM.png
// module id = 101
// module chunks = 48